import React, { useEffect, useState } from "react";
import { useChat } from "../context/ChatContext";

/**
 * ChatLauncher — bottone flottante in basso a destra per gli UTENTI
 * (studio/trader/real_estate). Riusa la stessa mascotte animata dell'assistente
 * AI admin, ma NON è un'AI: apre semplicemente la chat WhatsApp-style con
 * l'assistenza. Fumetto: "Chatta con noi". Mostra il pallino rosso non letti.
 */
export default function ChatLauncher() {
  const { user, setOpen, unread, open } = useChat();
  const [cookieVisible, setCookieVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      try { setCookieVisible(!localStorage.getItem("ah_cookie_consent_v1")); }
      catch { setCookieVisible(false); }
    };
    check();
    const iv = setInterval(check, 2000);
    return () => clearInterval(iv);
  }, []);

  // Solo utenti loggati non-admin; nascosto quando il pannello chat è aperto.
  if (!user || user.role === "admin" || open) return null;
  const hasUnread = unread > 0;

  return (
    <>
      <style>{`
        @keyframes chat-mascot-wave {
          0%, 55%, 100% { transform: rotate(0deg); }
          63% { transform: rotate(-14deg); }
          71% { transform: rotate(10deg); }
          79% { transform: rotate(-8deg); }
          87% { transform: rotate(4deg); }
        }
        @keyframes chat-mascot-idle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-3px); }
        }
        @keyframes chat-bubble-pop {
          0% { opacity: 0; transform: translateY(6px) scale(0.9); }
          12% { opacity: 1; transform: translateY(0) scale(1); }
          88% { opacity: 1; transform: translateY(0) scale(1); }
          100% { opacity: 0; transform: translateY(6px) scale(0.95); }
        }
        .chat-mascot-btn .chat-mascot-float { animation: chat-mascot-idle 3.2s ease-in-out infinite; display: block; }
        .chat-mascot-btn:hover .chat-mascot-float { animation: none; }
        .chat-mascot-img { transform-origin: 50% 90%; animation: chat-mascot-wave 5s ease-in-out infinite; }
        .chat-mascot-btn:hover .chat-mascot-img { animation-duration: 1.6s; }
        .chat-mascot-bubble { animation: chat-bubble-pop 6s ease-in-out infinite; animation-delay: 1.2s; }
        @media (prefers-reduced-motion: reduce) {
          .chat-mascot-float, .chat-mascot-img, .chat-mascot-bubble { animation: none !important; }
        }
      `}</style>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{ bottom: cookieVisible ? "9rem" : "1.25rem" }}
        className="chat-mascot-btn fixed right-5 z-40 group flex items-center justify-center w-[72px] h-[72px] rounded-full bg-gradient-to-br from-white to-amber-50 hover:from-amber-50 hover:to-amber-100 shadow-2xl hover:shadow-gold/40 ring-2 ring-gold/40 hover:ring-gold transition-all hover:scale-110"
        data-testid="chat-launcher-btn"
        data-unread={unread}
        title="Chatta con noi"
        aria-label="Chatta con noi"
      >
        <span className="chat-mascot-float pointer-events-none">
          <img
            src="/ai-mascot.png"
            alt=""
            draggable={false}
            className="chat-mascot-img w-[68px] h-[68px] object-contain select-none pointer-events-none drop-shadow"
          />
        </span>
        <span
          className="chat-mascot-bubble absolute -top-9 right-0 bg-white text-ink text-[11px] font-bold tracking-wide px-2.5 py-1 rounded-xl rounded-br-none shadow-lg border border-ink/10 whitespace-nowrap pointer-events-none"
          aria-hidden="true"
        >
          Chatta con noi <span className="text-gold">✦</span>
        </span>
        {hasUnread ? (
          <span
            className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-1 rounded-full bg-rose-600 ring-2 ring-white text-[10px] font-bold text-white flex items-center justify-center animate-bounce"
            data-testid="chat-launcher-unread"
          >
            {unread > 99 ? "99+" : unread}
          </span>
        ) : (
          <span className="absolute top-1 right-1 w-3 h-3 rounded-full bg-emerald-400 ring-2 ring-white animate-pulse" />
        )}
      </button>
    </>
  );
}
